import script from "./DownloadView.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadView.vue?vue&type=script&setup=true&lang=js"

import "./DownloadView.vue?vue&type=style&index=0&id=0da9f5be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da9f5be"]])

export default __exports__